import * as React from "react";
import classNames from "classnames";

export const TextField = field => {
    const { error, touched } = field.meta;

    const inputClasses = classNames({
        "text-input__input": true,
        dirty: field.input.value,
        invalid: error && touched
    });

    return (
        <div className="text-input">
            <input
                {...field.input}
                className={inputClasses}
                id={field.input.name}
                type={field.type || "text"}
                onFocus={field.onFocus}
                onBlur={field.onBlur}
                maxLength={field.maxLength}
                required={field.required}
            />
            <label htmlFor={field.input.name} className="text-input__label">
                {field.label} {field.required && <span className="required-star">*</span>}
            </label>
            {error && touched && <span className="text-input__error-msg">{error}</span>}
        </div>
    );
};
